import { TypographyProps } from '@mui/material';
import React from 'react';

import { SubtitleMediumBoldStyled, SubtitleMediumStyled } from './styles';

export const SubtitleMedium: React.FC<TypographyProps> = (props) => {
  return (
    <SubtitleMediumStyled variant="h1" {...props}>
      {props.children}
    </SubtitleMediumStyled>
  );
};

export const SubtitleMediumBold: React.FC<TypographyProps> = (props) => {
  return (
    <SubtitleMediumBoldStyled variant="h1" {...props}>
      {props.children}
    </SubtitleMediumBoldStyled>
  );
};